import { render, staticRenderFns } from "./calyrafit-marquee.vue?vue&type=template&id=22314eee&scoped=true&"
import script from "./calyrafit-marquee.vue?vue&type=script&lang=js&"
export * from "./calyrafit-marquee.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-marquee.vue?vue&type=style&index=0&id=22314eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22314eee",
  null
  
)

export default component.exports